// extracted by mini-css-extract-plugin
export default {"body":"Entry_body__n7AOP","wrap":"Entry_wrap__vURFa","button":"Entry_button__2FOIZ","field":"Entry_field__nO-xa"};